/** Route input never supplies NaN, infinity, negative values or empty-as-zero. */
export function recordingSeek(value: unknown): number | undefined {
  if (typeof value !== "number" && typeof value !== "string") return undefined;
  if (typeof value === "string" && !value.trim()) return undefined;
  const seconds = Number(value);
  return Number.isFinite(seconds) && seconds >= 0 ? seconds : undefined;
}
export function clampRecordingSeek(
  seconds: number,
  duration: number,
): number | undefined {
  return Number.isFinite(duration) &&
    duration > 0 &&
    Number.isFinite(seconds) &&
    seconds >= 0
    ? Math.min(seconds, duration)
    : undefined;
}
/** One-shot listener on the existing player. Cleanup prevents late seeks. */
export function observeRecordingSeek(
  video: HTMLVideoElement,
  seconds: number,
  state: { applied: boolean },
): () => void {
  const apply = () => {
    if (state.applied) return;
    const target = clampRecordingSeek(seconds, video.duration);
    if (target === undefined || video.readyState < 1) return;
    try {
      video.currentTime = target;
      state.applied = true;
    } catch {
      /* wait for metadata */
    }
  };
  video.addEventListener("loadedmetadata", apply);
  video.addEventListener("durationchange", apply);
  apply();
  return () => {
    video.removeEventListener("loadedmetadata", apply);
    video.removeEventListener("durationchange", apply);
  };
}
